/** Official Google Business listing: https://maps.app.goo.gl/d2heEbWpifjWDCNJ9 */
const MAP_OPEN_HREF = "https://maps.app.goo.gl/d2heEbWpifjWDCNJ9";
const MAP_EMBED_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1347.4!2d19.0854021!3d47.5347324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741db00421c380f%3A0xe62a9d3db73c2b49!2sMIZU%20Brunch%20%26%20Coffe!5e0!3m2!1shu!2shu!4v1721290000000!5m2!1shu!2shu";

function VisitMap({ title, openLabel, address }) {
  return (
    <div className="visit-map">
      <div className="visit-map-frame-wrap">
        <iframe
          className="visit-map-frame"
          title={title}
          src={MAP_EMBED_SRC}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
      <a
        className="visit-map-open"
        href={MAP_OPEN_HREF}
        target="_blank"
        rel="noopener noreferrer"
      >
        {openLabel}
        <span className="visually-hidden"> — {address}</span>
      </a>
    </div>
  );
}

export default VisitMap;
